/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div v-if="auth == 2" class="store_login_unit_manage_menu">企業管理者画面</div>
            <div v-if="auth == 5" class="store_login_unit_manage_menu">CSV出力管理者画面</div>
            <div class="admin_menu_top_unit menu_center" >

                <Message v-if="ApivalidationMessage || !this.addFormFlg" :validationMessage="alertMessage" /><br>
                <Message v-if="ApivalidationMessage" :validationMessage="ApivalidationMessage" />

                <form class="form_companyBrand" v-on:submit.prevent="onsubmit">
                    <div class="lavel_companyBrand right_comment">
                        <label for="companyid">企業コード</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label  id="companyid" name="companyid">{{brand.brandId}}</label>
                    </div>

                    <div class="lavel_companyBrand right_comment">
                        <img v-if="auth != 5" class="required" src="../assets/required.png" />
                        <label for="companyname">企業名</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label v-if="auth == 5" id="companynamelabel" name="companyname">{{brand.companyName}}</label>
                        <input v-else class="wd240" id="companyname" name="companyname" type="text" v-model="brand.companyName" maxlength="20"/><br>
                        <label id="companynameerror" class="lavel_error_font ">{{validation.companynameResult}}</label>
                    </div>

                    <div class="lavel_companyBrand right_comment">
                        <label for="companyurl">URL</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label  id="companyurl" name="companyurl">{{brand.url}}</label>
                    </div>

                    <div class="lavel_companyBrand right_comment">
                        <img v-if="auth != 5" class="required" src="../assets/required.png" />
                        <label for="companybrandname">ブランド名</label>
                    </div>
                    <div class="input_companyBrand left_comment">
                        <label v-if="auth == 5" id="companybrandnamelabel" name="companybrandname">{{brand.brandName}}</label>
                        <input v-else class="wd240" id="companybrandname" name="companybrandname" type="text" v-model="brand.brandName" maxlength="20"/><br>
                        <label id="companybrandnameerror" class="lavel_error_font ">{{validation.companybrandnameResult}}</label>
                    </div>

                    <div v-if="auth != 5" class="lavel_companyBrand right_comment">
                        <label for="companypostalcode">郵便番号</label>
                    </div>
                    <div v-if="auth != 5" class="input_companyBrand left_comment">
                        <input  class="wd240" id="companypostalcode" name="companypostalcode" type="text" v-model="brand.zipCode" maxlength="7"/><br>
                        <label>半角数字(ハイフンなし)で入力してください。</label>
                        <label id="companypostalcodeerror" class="lavel_error_font ">{{validation.companypostalcodeResult}}</label>
                    </div>

                    <div v-if="auth != 5" class="lavel_companyBrand right_comment">
                        <label for="companyaddress">企業住所</label>
                    </div>
                    <div v-if="auth != 5" class="input_companyBrand left_comment">
                        <input  class="wd240" id="companyaddress" name="companyaddress" type="text" v-model="brand.address" maxlength="40"/><br>
                        <label id="companyaddresserror" class="lavel_error_font ">{{validation.companyaddressResult}}</label>
                    </div>

                    <div v-if="auth != 5" class="lavel_companyBrand right_comment">
                        <label for="companydepartmentname">担当部署</label>
                    </div>
                    <div v-if="auth != 5" class="input_companyBrand left_comment">
                        <input  class="wd240" id="companydepartmentname" name="companydepartmentname" type="text" v-model="brand.departmentName" maxlength="30"/><br>
                        <label id="companydepartmentnameerror" class="lavel_error_font ">{{validation.companydepartmentnameResult}}</label>
                    </div>
                    <div v-if="auth != 5" class="lavel_companyBrand right_comment">
                        <label for="companyｒemarks">備考欄</label>
                    </div>
                    <div v-if="auth != 5" class="input_companyBrand left_comment">
                        <input  class="wd240" id="companyｒemarks" name="companyｒemarks" type="text" v-model="brand.remarks" maxlength="20"/><br>
                        <label id="companyｒemarkserror" class="lavel_error_font ">{{validation.companyremarksResult}}</label>
                    </div>

                    <div v-if="auth != 5" class="lavel_companyBrand right_comment">
                        <label for="companytell">連絡先電話番号</label>
                    </div>
                    <div v-if="auth != 5" class="input_companyBrand left_comment">
                        <input  class="wd240" id="companytell" name="companytell" type="text" v-model="brand.phoneNumber" maxlength="11"/><br>
                        <label>半角数字(ハイフンなし)で入力してください。</label>
                        <label id="companytellerror" class="lavel_error_font ">{{validation.companytellResult}}</label>
                    </div>



                    <div v-if="auth != 5" class="lavel_companyBrand right_comment">
                        <label for="companynowpass">現在の企業管理者パスワード</label>
                    </div>
                    <div v-if="auth != 5" class="input_companyBrand left_comment">
                        <input  class="wd240" id="companynowpass" name="companynowpass" type="password" v-model="editBrandForm.current_company_manager_pw" maxlength="128"/><br>
                        <label id="companynowpasserror" class="lavel_error_font ">{{validation.companynowpassResult}}</label>
                    </div>

                    <div v-if="auth != 5" class="lavel_companyBrand right_comment">
                        <label for="companypass">新しい企業管理者パスワード</label>
                    </div>
                    <div v-if="auth != 5" class="input_companyBrand left_comment">
                        <input  class="wd240" id="companypass" name="companypass" type="password" v-model="editBrandForm.company_manager_pw" maxlength="128"/><br>
                        <label>パスワードは、8桁以上128桁以内かつ半角英数記号(!"#$%&'()*+,-./:;&lt;=&gt;?@[]^_`{|}~)で入力してください。</label>
                        <label id="companypasserror" class="lavel_error_font ">{{validation.companypassResult}}</label>
                    </div>

                    <div v-if="auth != 5" class="lavel_companyBrand right_comment">
                        <label for="companyrepass">新しい企業管理者パスワード(確認用)</label>
                    </div>
                    <div v-if="auth != 5" class="input_companyBrand left_comment">
                        <input  class="wd240" id="companyrepass" name="companyrepass" type="password" v-model="editBrandForm.company_manager_pw_confirm" maxlength="128"/><br>
                        <label id="companyrepasserror" class="lavel_error_font ">{{validation.companyrepassResult}}</label>
                    </div>

                    <div v-if="auth == 5" class="lavel_companyBrand right_comment">
                      <label for="storecommonpass">店舗管理者共通パスワード</label>
                    </div>
                    <div v-if="auth == 5" class="input_companyBrand left_comment">
                        <input  class="wd240" id="storecommonpass" name="storecommonpass" type="password" v-model="editBrandForm.store_manager_pw" maxlength="128"/><br>
                        <label>パスワードは、8桁以上128桁以内かつ半角英数記号(!"#$%&'()*+,-./:;&lt;=&gt;?@[]^_`{|}~)で入力してください。</label>
                        <label id="storecommonpasserror" class="lavel_error_font ">{{validation.storecommonpassResult}}</label>
                    </div>

                    <div v-if="auth == 5" class="lavel_companyBrand right_comment">
                        <label for="storecommonrepass">店舗管理者共通パスワード(確認用)</label>
                    </div>
                    <div v-if="auth == 5" class="input_companyBrand left_comment">
                        <input  class="wd240" id="storecommonrepass" name="storecommonrepass" type="password" v-model="editBrandForm.store_manager_pw_confirm" maxlength="128"/><br>
                        <label id="storecommonrepasserror" class="lavel_error_font ">{{validation.storecommonrepassResult}}</label>
                    </div>

                    <div v-if="auth == 2" class="lavel_companyBrand right_comment">
                        <label for="otherpass">その他管理者パスワード</label>
                    </div>
                    <div v-if="auth == 2" class="input_companyBrand left_comment">
                        <input  class="wd240" id="otherpass" name="otherpass" type="password" v-model="editBrandForm.other_manager_pw" maxlength="128"/><br>
                        <label>パスワードは、8桁以上128桁以内かつ半角英数記号(!"#$%&'()*+,-./:;&lt;=&gt;?@[]^_`{|}~)で入力してください。</label>
                        <label id="otherpasserror" class="lavel_error_font ">{{validation.otherpassResult}}</label>
                    </div>

                    <div v-if="auth == 2" class="lavel_companyBrand right_comment">
                        <label for="otherrepass">その他管理者パスワード(確認用)</label>
                    </div>
                    <div v-if="auth == 2" class="input_companyBrand left_comment">
                        <input  class="wd240" id="otherrepass" name="otherrepass" type="password" v-model="editBrandForm.other_manager_pw_confirm" maxlength="128"/><br>
                    </div>

                    <div v-if="auth == 2" class="lavel_companyBrand right_comment">
                        <label for="heatStrokeSet">熱中症アラート使用</label>
                    </div>
                    <div v-if="auth == 2" class="input_companyBrand left_comment">
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="heatStrokeSet_id1" name="checkdis" type="radio" value='1' v-model="brand.heatStrokeEnable">
                            <label class="form-check-label" for="heatStrokeSet_id1">有</label>
                        </div>
                        <div class="form-check form-check-inline wd70">
                            <input class="form-check-input display_radio" id="heatStrokeSet_id2" name="checkdis" type="radio" value='0' v-model="brand.heatStrokeEnable">
                            <label class="form-check-label" for="heatStrokeSet_id2">無</label>
                        </div>
                        <br>
                        <label id="heatStrokeSeterror" class="lavel_error_font ">{{validation.companyHeatStrokeEnableReult}}</label>
                    </div>


                </form>
            </div>
            <div class="btn_submit letter_spa">
                <a href="#" @click.prevent.stop="checkFrom">更新</a>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">企業編集</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>企業編集が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import ValidationRule from '@/app/config/validationRule.js'
    import Message from '@/app/components/Message.vue'
export default {
    name: 'CommpanyBraindEdit',
    components: {
        PulseLoader,
        Message
    },
    data: function () {
        return {
            ApivalidationMessage:'',
            alertMessage:'入力エラーがあります。',
            isInitLoading:true,
            isLoading:false,
            showContent:false,
            brand: {},
            editBrandForm: {
                current_company_manager_pw: '',
                company_manager_pw: '',
                company_manager_pw_confirm: '',
                store_manager_pw: '',
                store_manager_pw_confirm: '',
                other_manager_pw: '',
                other_manager_pw_confirm: '',
            },
            validation:{
                companyidResult: "",
                companynameResult: "",
                companyurlResult: "",
                companybrandnameResult: "",
                companypostalcodeResult: "",
                companyaddressResult: "",
                companydepartmentnameResult: "",
                companyremarksResult: "",
                companytellResult: "",
                companynowpassResult: "",
                companypassResult: "",
                companyrepassResult: "",
                storecommonpassResult: "",
                storecommonrepassResult: "",
                otherpassResult: "",
                companyHeatStrokeEnableResult:"",
            },
            addFormFlg: true,
            auth: ''
        }
    },
    computed: {
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        id() {
            return this.$store.getters['brand/selectedBrandId'];
        }
    },
    async created() {
        //権限情報を取得
        this.auth = this.$store.getters['manager/manager'].authorityKbn;

        await this.$axios
            .get(this.$apiEndpoint + 'manage/brand/' + this.id)
            .then(response => (this.brand = response['data']['brand']))
            .catch((err) => {
                let error = {
                    button: {
                        path: {name: 'top', params:{brandPath: this.brandPath}}
                    }}
                if (err.customError) {
                    error = Object.assign(error, err.customError)
                }
                this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            }).finally(()=> this.isInitLoading = false);

    },
    methods:{
        checkFrom: async function(){

            this.addFormFlg = true;
            this.isLoading = true;

            //エラー内容初期化
            this.clearError();

            //バリデーションチェック
            //必須チェック
            if(!this.brand.companyName){
                this.validation.companynameResult="企業名を入力してください。"
                this.addFormFlg = false;
            }
            if(!this.brand.brandName){
                this.validation.companybrandnameResult="ブランドを入力してください。"
                this.addFormFlg = false;
            }

            // 条件必須
            // パスワード
            if(this.editBrandForm.company_manager_pw !== "" || this.editBrandForm.company_manager_pw_confirm !== ""){
                if(this.editBrandForm.current_company_manager_pw == ""){
                    this.validation.companynowpassResult="現在の企業管理者パスワードを入力してください。"
                    this.addFormFlg = false;
                }
            }


            //バリデーションチェック(企業コード)
            //桁数チェック
            if(String(this.brand.brandId).length > 20 && this.validation.companyidResult ==""){
                this.validation.companyidResult="企業コードは20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.brand.companyName).length > 20 && this.validation.companynameResult == ""){
                this.validation.companynameResult="企業名は20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.brand.url).length > 100 && this.validation.companyurlResult == ""){
                this.validation.companyurlResult="URLは100桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.brand.brandName).length > 20 && this.validation.companybrandnameResult == ""){
                this.validation.companybrandnameResult="ブランド名は20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(this.brand.zipCode !== '' && this.brand.zipCode !== null){
                if(String(this.brand.zipCode).length !== 7 && this.validation.companypostalcodeResult == ""){
                    this.validation.companypostalcodeResult="郵便番号は7桁で入力してください。"
                    this.addFormFlg = false;
                }
            }
            if(String(this.brand.address).length > 40 && this.validation.companyaddressResult == ""){
                this.validation.companyaddressResult="企業住所は40桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.brand.departmentName).length > 30 && this.validation.companydepartmentnameResult == ""){
                this.validation.companydepartmentnameResult="担当部署は30桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(String(this.brand.remarks).length > 20 && this.validation.companyremarksResult == ""){
                this.validation.companyremarksResult="備考欄は20桁以内で入力してください。"
                this.addFormFlg = false;
            }
            if(this.brand.phoneNumber !== '' && this.brand.phoneNumber !== null){
                if((String(this.brand.phoneNumber).length < 10 || String(this.brand.phoneNumber).length > 11) && this.validation.companytellResult == ""){
                    this.validation.companytellResult="連絡先電話番号は10桁以上11桁以内で入力してください。"
                    this.addFormFlg = false;
                }
            }
            if(this.editBrandForm.company_manager_pw !== '' ){
                if((String(this.editBrandForm.company_manager_pw).length < 8 || String(this.editBrandForm.company_manager_pw).length > 128)
                    && this.validation.companypassResult == ""){
                    this.validation.companypassResult="企業管理者パスワードは8桁以上、128桁以内で入力してください。"
                    this.addFormFlg = false;
                }
            }
            if(this.editBrandForm.store_manager_pw !== ''){
              if((String(this.editBrandForm.store_manager_pw).length < 8 || String(this.editBrandForm.store_manager_pw).length >128)
                  && this.validation.storecommonpassResult == ""){
                this.validation.storecommonpassResult="店舗管理者共通パスワードは8桁以上、128桁以内で入力してください。"
                this.addFormFlg = false;
              }
            }
            if(this.editBrandForm.other_manager_pw !== ''){
                if((String(this.editBrandForm.other_manager_pw).length < 8 || String(this.editBrandForm.other_manager_pw).length >128)
                    && this.validation.otherpassResult == ""){
                    this.validation.otherpassResult="その他管理者パスワードは8桁以上、128桁以内で入力してください。"
                    this.addFormFlg = false;
                }
            }


            //文字種チェック
            if(this.brand.brandId !== null && !this.checkStrong(this.brand.brandId) && this.validation.companyidResult == ""){
                this.validation.companyidResult="企業コードは半角英数で入力してください。"
                this.addFormFlg = false;
            }
            if(this.brand.companyName !== null && !this.checkStrong2(this.brand.companyName) && this.validation.companynameResult == ""){
                this.validation.companynameResult="企業名は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.brand.url !== null && !this.checkStrong3(this.brand.url) && this.validation.companyurlResult == ""){
                this.validation.companyurlResult="URLは半角英数記号で入力してください。"
                this.addFormFlg = false;
            }
            if(this.brand.brandName !== null && !this.checkStrong2(this.brand.brandName) && this.validation.companybrandnameResult == ""){
                this.validation.companybrandnameResult="ブランド名は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.brand.zipCode !== null && this.brand.zipCode !== '' && !this.checkNumberZipCode(this.brand.zipCode)
                && this.validation.companypostalcodeResult == ""){
                this.validation.companypostalcodeResult="郵便番号は半角数字で入力してください。"
                this.addFormFlg = false;
            }
            if(this.brand.address !== null && !this.checkAddress(this.brand.address) && this.validation.companyaddressResult == ""){
                this.validation.companyaddressResult="企業住所は全半角英数漢ひらカナ記号（・ー-）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.brand.departmentName!== null && !this.checkStrong2(this.brand.departmentName) && this.validation.companydepartmentnameResult == ""){
                this.validation.companydepartmentnameResult="担当部署は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.brand.remarks !== null && !this.checkStrong2(this.brand.remarks) && this.validation.companyremarksResult == ""){
                this.validation.companyremarksResult="備考欄は全半角英数漢ひらカナ記号（・ー）スペースで入力してください。"
                this.addFormFlg = false;
            }
            if(this.brand.phoneNumber !== null && this.brand.phoneNumber !== ''
                && !this.checkNumber(this.brand.phoneNumber) && this.validation.companytellResult == ""){
                this.validation.companytellResult="連絡先電話番号は半角数字で入力してください。"
                this.addFormFlg = false;
            }
            if(this.editBrandForm.company_manager_pw !== '' && !this.checkStrong4(this.editBrandForm.company_manager_pw) && this.validation.companypassResult == ""){
                this.validation.companypassResult="企業管理者パスワードは半角英数記号で入力してください。"
                this.addFormFlg = false;
            }
            if(this.editBrandForm.store_manager_pw !== '' && !this.checkStrong4(this.editBrandForm.store_manager_pw) && this.validation.storecommonpassResult == ""){
              this.validation.storecommonpassResult="店舗管理者共通パスワードは半角英数記号で入力してください。"
              this.addFormFlg = false;
            }
            if(this.editBrandForm.other_manager_pw !== '' && !this.checkStrong4(this.editBrandForm.other_manager_pw) && this.validation.otherpassResult == ""){
                this.validation.otherpassResult="その他管理者パスワードは半角英数記号で入力してください。"
                this.addFormFlg = false;
            }
            //0か1であること
            if(this.brand.heatStrokeEnable !== null && this.brand.heatStrokeEnable !== ''
                && (!this.checkNumber(this.brand.heatStrokeEnable) || (this.brand.heatStrokeEnable != 0 && this.brand.heatStrokeEnable != 1)) && this.validation.companyHeatStrokeEnableResult == ""){
                this.validation.companyHeatStrokeEnableResult="熱中症アラート使用の形式が正しくありません。"
                this.addFormFlg = false;
            }


            //pwチェック
            //企業パスワード
            if(this.editBrandForm.company_manager_pw !== "" || this.editBrandForm.company_manager_pw_confirm !== ""){
                if(this.editBrandForm.company_manager_pw !== this.editBrandForm.company_manager_pw_confirm && this.validation.companypassResult == ""){
                    this.validation.companypassResult="パスワードが一致しません。入力しなおしてください。"
                    this.addFormFlg = false;
                }
            }
            //店舗共通パスワード
            if(this.editBrandForm.store_manager_pw !== "" || this.editBrandForm.store_manager_pw_confirm !== ""){
              if(this.editBrandForm.store_manager_pw !== this.editBrandForm.store_manager_pw_confirm && this.validation.storecommonpassResult == ""){
                this.validation.storecommonpassResult="パスワードが一致しません。入力しなおしてください。"
                this.addFormFlg = false;
              }
            }
            //その他管理者パスワード
            if(this.editBrandForm.other_manager_pw !== "" || this.editBrandForm.other_manager_pw_confirm !== ""){
                if(this.editBrandForm.other_manager_pw !== this.editBrandForm.other_manager_pw_confirm && this.validation.otherpassResult == ""){
                    this.validation.otherpassResult="パスワードが一致しません。入力しなおしてください。"
                    this.addFormFlg = false;
                }
            }

            // バリデーション
            if(!this.addFormFlg){
                this.isLoading = false;
                this.scrollTop();
                return null;
            }

            if(this.addFormFlg == true){

                var apiResponseFlg = true;

                // 企業情報の更新
                //TODO:入力された内容以外は除外
                var requestBrand = {
                    company_name: this.brand.companyName,
                    brand_name: this.brand.brandName,
                    zip_code: this.brand.zipCode,
                    address: this.brand.address,
                    department_name: this.brand.departmentName,
                    remarks: this.brand.remarks,
                    phone_number: this.brand.phoneNumber,
                    update_datetime: this.dateFormat(this.brand.updateDatetime),
                    heat_stroke_enable:this.brand.heatStrokeEnable
                }
                var requestBody = Object.assign(requestBrand, this.editBrandForm);
                await this.$axios
                    .post(this.$apiEndpoint + 'manage/brand/' + this.id, requestBody)
                    .then(response => (this.brand = response['data']['brand']))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.ApivalidationMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);

                if(apiResponseFlg){
                 this.openModel()
                }
            }

        },
        //半角英数字のチェック
        checkStrong:function(inputdata){
            var re = new RegExp(/^[0-9A-Za-z]+$/);
            return re.test(inputdata);
        },
        //半角数字のチェック
        checkNumber:function(inputdata){
            var re = new RegExp(/^[0-9]*$/);
            return re.test(inputdata);
        },
        //半角数字のチェック
        checkNumberZipCode:function(inputdata){
            var re = new RegExp(/^[0-9]{7}$/);
            return re.test(inputdata);
        },
        //全半角英数漢ひらカナ
        checkStrong2:function(inputdata){
            var re = new RegExp(ValidationRule.ZenHankakuEiSuuKanaKanjiSpace);
            return re.test(inputdata);
        },
        //半角英数記号 + 記号
        checkStrong3:function(inputdata){
            var re = new RegExp(/^[a-zA-Z0-9-:/.?=&]+$/);
            return re.test(inputdata);
        },
        //半角英数記号
        checkStrong4:function(inputdata){
            var re = new RegExp(/^[0-9a-zA-Z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/);
            //var re = new RegExp(/^[0-9a-zA-Z[\]]*$/);
            return re.test(inputdata);
        },
        //住所（全半角英数漢ひらカナ記号（・ー-））
        checkAddress:function(inputdata){
            var re = new RegExp(ValidationRule.Address);
            return re.test(inputdata);
        },
        clearError:function(){
            //メッセージ初期化
            this.validation.companyidResult = "";
            this.validation.companynameResult = "";
            this.validation.companyurlResult = "";
            this.validation.companybrandnameResult = "";
            this.validation.companypostalcodeResult = "";
            this.validation.companyaddressResult = "";
            this.validation.companydepartmentnameResult = "";
            this.validation.companyremarksResult = "";
            this.validation.companytellResult = "";
            this.validation.companypassResult = "";
            this.validation.companyrepassResult = "";
            this.validation.storecommonpassResult = "";
            this.validation.storecommonrepassResult = "";
            this.validation.otherpassResult = "";
            this.ApivalidationMessage = "";
            this.validation.companynowpassResult = "";
            this.validation.companyHeatStrokeEnableResult = "";
        },
        openModel() {
            this.showContent = true;
        },
        closeModel() {
            this.showContent = false;
            this.$router.push({name: 'manageCommpanyBrandList', params: {brandId: this.userButtanId}});
        },
        dateFormat(date){
            let format_str = date.replace(/-/g, '/');
            return format_str;
        },
        scrollTop() {
            window.scrollTo(0,0);
        }
    }
}
</script>